module.exports = __webpack_public_path__ + "static/media/product-placeholder.df9aa745.svg";